import cn from 'classnames';
import { ApolloError } from '@apollo/client';
import { getFaIcon } from '@odin-labs/components';
import { faSitemap } from 'components/icons';
import { GetOrganizationContainerOrganizationInfoQuery } from 'apollo/generated/client-operations';

export type OrganizationInfo =
  GetOrganizationContainerOrganizationInfoQuery['getOrganization'];

export const OrganizationIcon = getFaIcon({
  icon: faSitemap,
  className: cn('odin-text-base odin-text-odin-primary'),
});

export type OrganizationTabApi = {
  refetchData: () => void;
};

export type OrganizationTabProps = {
  organization: OrganizationInfo;
  loading?: boolean;
  error?: ApolloError;
  onTabApiChange?: (api: OrganizationTabApi) => void;
  refetchOrganizationData?: () => void;
  openAddDeveloperModal?: () => void;
  openAddContractorModal?: () => void;
};
